// extracted by mini-css-extract-plugin
export var measureBox = "_74-0";